import React from 'react'
import MUIRichTextEditor from './MUIRichTextEditor'

const RichTextEditor = ({ textStatus, ...props }) => {
  return <MUIRichTextEditor {...props} textStatus={textStatus} />
}

export default RichTextEditor
